/**
 * Правый блок шапки: кто вошёл и что он может сделать лично для себя.
 *
 * Под логином — выпадающий список личных настроек: полный email (в шапке он
 * может обрезаться, а здесь его видно целиком и можно выделить) и смена
 * пароля. «Выход» остаётся в шапке отдельной кнопкой.
 *
 * Админские разделы сюда не попадают: они живут в навигации слева.
 */

import { ReactNode } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { NavDropdown } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useLogout } from '../Logout';
import { useAccess } from '../../access/PlatformAccess';

interface UserActionsProps {
    login: string;
    missionPlannerUrl: string;
    /** Закрыть мобильную панель после перехода. */
    onNavigate?: () => void;
}

function UserActions({ login, missionPlannerUrl, onNavigate }: UserActionsProps): ReactNode {
    const access = useAccess();

    const logout = useLogout();
    const { t } = useTranslation(['nav_menu']);

    return (
        <>
            <NavDropdown
                id='app-header-user-menu'
                className='app-header-user-menu'
                title={<span className='app-header-user' title={login}>{login}</span>}
                align='end'
                menuVariant='dark'
            >
                <NavDropdown.ItemText className='app-header-user-email'>
                    {login}
                </NavDropdown.ItemText>
                <NavDropdown.Divider />
                <NavDropdown.Item as={Link} to='/account/password' onClick={onNavigate}>
                    {t('change_password')}
                </NavDropdown.Item>
            </NavDropdown>

            {/* Личные разделы модели доступа стенда, например подписки. */}
            {access.userLinks.map((link) =>
                <NavLink
                    key={link.to}
                    to={link.to}
                    onClick={onNavigate}
                    className={({ isActive }) =>
                        'app-header-link' + (isActive ? ' app-header-link-active' : '')
                    }
                >
                    {t(link.labelKey)}
                </NavLink>
            )}

            {/* Ссылку на сборку отдаёт сервер: страница /mp ведёт на свою,
                зашитую версию, эта — на актуальную. */}
            {missionPlannerUrl &&
                <button
                    type='button'
                    className='app-header-link'
                    onClick={() => { window.open(missionPlannerUrl, '_blank'); onNavigate?.(); }}
                >
                    {t('download_mp_short')}
                </button>
            }

            <button
                type='button'
                className='app-header-link app-header-logout'
                onClick={logout}
            >
                {t('logout')}
            </button>
        </>
    );
}

export default UserActions;
